export const ConvertToUTC = (dateString: string): string => {

    var dateValue = new Date(dateString);

    return dateValue.toISOString();
}